import React from 'react'; 
import { Form, Button, Row, Col, ListGroup, Table, ButtonGroup } from "react-bootstrap";
import ImageUploading from 'react-images-uploading';

export default function GalleryGuidelisting() {
    const [images, setImages] = React.useState([]);
    const maxNumber = 69;
    
    const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
    };
    return(
        <section className="admin-section">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-12">
                        <div className="admin-edit gallery-guide">
                        <h1>AD Sign Up</h1>
                          <div className='gry-bg'>
                               <h3> Subscription Details: </h3>
                               <p>
                                Subscription Details:<br /> 
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt 
                                ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation 
                                ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in 
                                reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint 
                                occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est 
                                laborum. 
                            </p>
                            </div>
                            <Form>
                                <Row>
                                <Col md="8">
                                        <Form.Group  className="mb-3" controlId="formHorizontalEmail">
                                            <Form.Label > Website <span className='star'>*</span> </Form.Label>
                                            <Form.Control type="text" placeholder="Website" />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                    <Form.Group>

<ImageUploading
value={images}
onChange={onChange}
maxNumber={maxNumber}
dataURLKey="data_url"
>
{({
imageList,
onImageUpload,
onImageRemoveAll,
onImageUpdate,
onImageRemove,
isDragging,
dragProps,
}) => (
// write your building UI
<div className="choose-file">
<button type='button'
style={isDragging ? { color: 'red' } : undefined}
onClick={onImageUpload}
{...dragProps}
>
<img src={process.env.PUBLIC_URL+'/images/crop-image.png'}/>
</button>

{imageList.map((image, index) => (
<div key={index} className="image-item">
<img src={image['data_url']} alt="" width="100" />
<div className="image-item__btn-wrapper">
<button type='button' onClick={() => onImageUpdate(index)}>Update</button>
<button type='button' onClick={() => onImageRemove(index)}>Remove</button>
</div>
</div>
))}
</div>
)}
</ImageUploading>
<br/>
</Form.Group>
                                        <p>
                                            File Specifications: jpg, sRGB, 72 dpi, {'< ='}2MB
                                            File names cannot contain any apostrophes or 
                                            special characters ({'"  @ \ / | : < > *'}).<br />
                                            <i>Images will be cropped to a 3:2 (4x6) aspect ratio.</i>
                                        </p>
                                    </Col>
                                </Row>
                                <hr/>
                                <div className='text-center'>
<Button className='common-btn'>Next</Button>{' '}
<Button className='cancel-btn'>CANCEL</Button>{' '}
</div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}